const qs = require('qs');

function load_stripe() {
    return $.when(
        $.getScript( "https://js.stripe.com/v3/" ),
        $.Deferred(function( deferred ){
            $( deferred.resolve );
        })
    ).done(function(){});
}

document.addEventListener(
    'fm-subscription-selected', e => {
        (async data => {
            const setLoading = (isLoading, noDisable=false) => {
                if (isLoading) {
                    el[0].querySelector(".payment-form-working").classList.add("display");

                    // Disable the button and show a spinner
                    if(!noDisable) {
                        el[0].querySelector(".payment-form-submit").disabled = true;
                    }
                    el[0].querySelector(".payment-form-spinner").classList.remove("hidden");
                    el[0].querySelector(".payment-form-button-text").classList.add("hidden");
                } else {
                    el[0].querySelector(".payment-form-working").classList.remove("display");

                    el[0].querySelector(".payment-form-submit").disabled = false;
                    el[0].querySelector(".payment-form-spinner").classList.add("hidden");
                    el[0].querySelector(".payment-form-button-text").classList.remove("hidden");
                }
            }

            const validateEmail = (email) => {
                return String(email)
                    .toLowerCase()
                    .match(
                        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    );
            };

            const clearErrors = () => {
                const spans = el[0].querySelectorAll('.customer-field-error');
                const inputs = el[0].querySelectorAll('.error');
                for (let i = 0; i < spans.length; i++) {
                    spans[i].remove();
                }
                [].forEach.call(inputs, function (el) {
                    el.classList.remove('error');
                });

            }


            const { detail } = e;
            const choice = detail.el.closest('div.subscribe-choice');
            const parent = choice.next();
            const el = parent.find('.dpl-subscribe-form-form');
//console.log(el);
            parent.removeClass('hidden');
            $('.dpl-subscribe-form.hidden').remove();

            document.dispatchEvent(
                new CustomEvent('ui-repaint')
            );
            let stage = 1,
                elements,
                first_name,
                last_name,
                mailchimp_list,
                mailchimp_interests,
                customer_id,
                products = [],
                skipfirst = false,
                password;

            if (el.data('skipfirst')) {
                skipfirst = true;
                setLoading(true, true);
            }

            if (el.length > 0) {
                await load_stripe();

                const stripe =
                    Stripe(Subscribe.stripe_publishable_key);

                const product_id = detail.product_id;
                const price_id = detail.price_id;
                const site_membership_id = el.data('site_membership_id');
                const success_url = el.data('success');
                const success_msg = el.data('successmsg');
                const email_template = el.data('etemplate');
                const block_id = el.data('blockid');
                const trial_period_days = el.data('trial_period_days');
                const search_keyword = el.data('search_keyword');
                const coupon = (detail.coupon ? detail.coupon : false);
                const product_req = await fetch(Subscribe.stripe_api_target_url + 'products/' + product_id);
                let product = await product_req.json();

                if (product.status === 'SUCCESS') {
                    let {fm_products} = product.products[0].metadata;
                    fm_products = fm_products.split(',');

                    const handleSubmit = async (e) => {
                        e.preventDefault();
                        setLoading(true);
                        clearErrors();
                        document.dispatchEvent(
                            new CustomEvent('fm-subscription-submit')
                        );

                        const form = el[0];

                        const formData = new URLSearchParams(new FormData(form)).toString();
                        const objData = qs.parse(formData);

                        const {data, email} = objData;

                        let errors = {},
                            meta = {
                                email,
                                site_membership_id
                            };

                        if(search_keyword) {
                            meta[search_keyword] = search_keyword;
                        }

                        first_name = (data.first_name ? data.first_name : '');
                        last_name = (data.last_name ? data.last_name : '');
                        mailchimp_list = (data.mailchimp_list ? data.mailchimp_list : '');
                        mailchimp_interests = (data.mailchimp_interests ? data.mailchimp_interests : '');

                        if (stage === 1) {
                            if (!skipfirst) {
                                if (!data.first_name) {
                                    errors.first_name = "Please enter your first name.";
                                }
                                if (!data.last_name) {
                                    errors.last_name = "Please enter your last name.";
                                }
                                if (!email) {
                                    errors.email = "Please enter your e-mail.";
                                }
                                if (!validateEmail(email)) {
                                    errors.email = "Please enter a valid e-mail.";
                                }

                                // Filter for additional validation if needed
                                const fm_js_filter_subscribe_validation_step_1 =
                                    wpdk_apply_filters( 'fm_js_filter_subscribe_validation_step_1', '' );
                                if(fm_js_filter_subscribe_validation_step_1.errors) {
                                    for(let i=0; i<fm_js_filter_subscribe_validation_step_1.errors.length;i++) {
                                        errors[fm_js_filter_subscribe_validation_step_1.errors[i].name] = fm_js_filter_subscribe_validation_step_1.errors[i].message;
                                    }
                                }

                                if (Object.getOwnPropertyNames(errors).length > 0) {
                                    for (const [key, value] of Object.entries(errors)) {
                                        const parentEl = document.querySelector('#customer-' + key);
                                        parentEl.classList.add('error');
                                        const newErrorEl = document.createElement('span');
                                        newErrorEl.className = 'customer-field-error';
                                        newErrorEl.textContent = value;
                                        parentEl.parentNode.insertBefore(newErrorEl, parentEl.nextSibling);
                                    }

                                    setLoading(false);
                                    return false;
                                }
                            }

                            // Break default subscription here if different logic
                            const fm_js_filter_is_not_normal_subscription =
                                wpdk_apply_filters( 'fm_js_filter_is_not_normal_subscription', false );
                            if(fm_js_filter_is_not_normal_subscription) {
                                wpdk_do_action('fm_js_filter_do_alternative_subscription_stuff',
                                    stripe,
                                    data,
                                    email,
                                    price_id,
                                    fm_products,
                                    success_url,
                                    success_msg,
                                    mailchimp_list,
                                    mailchimp_interests,
                                    email_template,
                                    skipfirst,
                                    search_keyword
                                );
                                return false;
                            }

                            const fm_js_filter_meta =
                                wpdk_apply_filters( 'fm_js_filter_subscribe_meta', false );
                            if(fm_js_filter_meta) {
                                meta = {...fm_js_filter_meta, ...meta};
                            }

                            let customer = false;

                            if (!skipfirst) {
                                const check_customer = await fetch(Subscribe.stripe_api_target_url, {
                                    method: 'POST',
                                    mode: 'same-origin',
                                    body: JSON.stringify({
                                        'trigger': 'check_customer',
                                        email
                                    })
                                });

                                customer = await check_customer.json();
                            }

                            if (customer.status === 'SUCCESS') {
                                // customer does exist
                                $('.dpl-subscribe-form-login').removeClass('hidden');
                                $('.payment-form-submit').remove();
                                $('input#subscriber-email').val(email);
                                document.dispatchEvent(
                                    new CustomEvent('ui-repaint')
                                );

                                return false;

                            } else {
                                // customer doesn't exist
                                const create_customer = await fetch(Subscribe.stripe_api_target_url, {
                                    method: 'POST',
                                    mode: 'same-origin',
                                    body: JSON.stringify({
                                        'trigger': 'create_customer',
                                        email,
                                        data
                                    })
                                });

                                const customer_data = await create_customer.json();
                                if (customer_data.status === 'ERROR') {
                                    alert(customer_data.message);
                                    return false;
                                }

                                customer_id = customer_data.params.stripe_id;

                                let create_subscription_args = {
                                    'trigger': 'create_subscription',
                                    customer_id,
                                    price_id,
                                    data,
                                    meta,
                                    block_id
                                };

                                if(trial_period_days) {
                                    create_subscription_args.trial_period_days = trial_period_days;
                                }
                                if(coupon) {
                                    create_subscription_args.coupon = coupon;
                                }

                                const create_subscription = await fetch(Subscribe.stripe_api_target_url, {
                                    method: 'POST',
                                    mode: 'same-origin',
                                    body: JSON.stringify(create_subscription_args)
                                });

                                const subscription_data = await create_subscription.json();

                                for (let i = 0; i < fm_products.length; i++) {
                                    products.push({
                                        name: fm_products[i],
                                        expires: "" + subscription_data.subscription.current_period_end + ""
                                    })
                                }

                                const {clientSecret} = subscription_data;
                                if (clientSecret) {
                                    const options = {clientSecret};
                                    elements = stripe.elements(options);
                                    const paymentElement = elements.create('payment');
                                    paymentElement.mount('#stripe-elements');

                                }
                            }

                            el.find('.subscribe-form-payment-details').removeClass('hidden');
                            el.find('.subscribe-form-personal-details').addClass('hidden');

                            stage = 2;
                            setLoading(false);
                            setTimeout(function () {
                                document.dispatchEvent(
                                    new CustomEvent('ui-repaint')
                                );
                            }, 1500);

                            return false;

                        }
                        if (stage === 2) {
                            const {paymentIntent, error} = await stripe.confirmPayment({
                                elements,
                                confirmParams: {
                                    return_url: success_url,
                                },
                                redirect: 'if_required'
                            });

                            if(trial_period_days) {
                                const refund_initial = await fetch(Subscribe.stripe_api_target_url, {
                                    method: 'POST',
                                    mode: 'same-origin',
                                    body: JSON.stringify({
                                        'trigger': 'refund_initial',
                                        paymentIntentId: paymentIntent.id
                                    })
                                })
                            }

                            if (!error) {
                                const { payment_method } = paymentIntent;
                                const update_payment_method_args = {
                                    'trigger': 'update_payment_method',
                                    customer_id, payment_method
                                }
                                const update_payment_method = await fetch(Subscribe.stripe_api_target_url, {
                                    method: 'POST',
                                    mode: 'same-origin',
                                    body: JSON.stringify(update_payment_method_args)
                                });

                                const update_payment_method_data = await update_payment_method.json();

                                const create_subscription_db = await fetch(Subscribe.stripe_api_target_url, {
                                    method: 'POST',
                                    mode: 'same-origin',
                                    body: JSON.stringify({
                                        'trigger': 'create_subscriber_db',
                                        email,
                                        first_name,
                                        last_name,
                                        customer_id,
                                        products,
                                        data
                                    })
                                });

                                const create_subscription_db_data = await create_subscription_db.json();

                                if (create_subscription_db_data.status === 'ACCOUNT_EXISTS') {
                                    const update_subscription_db = await fetch(Subscribe.stripe_api_target_url, {
                                        method: 'POST',
                                        mode: 'same-origin',
                                        body: JSON.stringify({
                                            'trigger': 'update_subscriber_db',
                                            email,
                                            first_name,
                                            last_name,
                                            customer_id,
                                            products,
                                            data
                                        })
                                    });

                                    const update_subscription_db_data = await update_subscription_db.json();

                                    if (skipfirst) {
                                        const sign_out = await fetch(Subscribe.stripe_api_target_url, {
                                            method: 'POST',
                                            mode: 'same-origin',
                                            body: JSON.stringify({
                                                'trigger': 'sign_out'
                                            })
                                        });

                                        const sign_out_data = await sign_out.json();

                                    }

                                    if(success_msg) {
                                        el.html(atob(success_msg));
                                    }

                                    setTimeout(() => {
                                        if (success_url) {
                                            window.location.replace(success_url);
                                        }
                                        location.reload();
                                    },5000);
                                } else {
                                    password = create_subscription_db_data.temp_password;
                                }

                                const send_email = await fetch(Subscribe.stripe_api_target_url, {
                                    method: 'POST',
                                    mode: 'same-origin',
                                    body: JSON.stringify({
                                        'trigger': 'send_email',
                                        email,
                                        template:email_template,
                                        vars: [
                                            {
                                                'name' : 'FNAME',
                                                'content' : first_name
                                            }
                                        ]
                                    })
                                });

                                const send_email_data = await send_email.json();

                                if(mailchimp_list) {
                                    const update_mailchimp = await fetch(Subscribe.stripe_api_target_url, {
                                        method: 'POST',
                                        mode: 'same-origin',
                                        body: JSON.stringify({
                                            'trigger': 'update_mailchimp',
                                            email,
                                            name : first_name + ' ' + last_name,
                                            mailchimp_list,
                                            mailchimp_interests
                                        })
                                    });

                                    const update_mailchimp_data = await update_mailchimp.json();
                                }

                                if (typeof rewardful === "function") {
                                    rewardful('convert', {email});
                                }
                            } else {
                                alert(error.message);
                                setLoading(false);
                                return false;
                            }

                            if (!skipfirst) {
                                const sign_in = await fetch(Subscribe.stripe_api_target_url, {
                                    method: 'POST',
                                    mode: 'same-origin',
                                    body: JSON.stringify({
                                        'trigger': 'sign_in',
                                        email,
                                        password
                                    })
                                });
                                const sign_in_data = await sign_in.json();
                                el.find('input#customer-password-session').val(sign_in_data.params.session);
                                el.find('input#customer-password-email').val(sign_in_data.params.email);

                                el.find('.subscribe-form-payment-details').addClass('hidden');
                                el.find('.subscribe-form-password').removeClass('hidden');
                                stage = 3;
                            }

                            setLoading(false);

                            return false;
                        }

                        if (stage === 3) {
                            const session = el.find('#customer-password-session').val();
                            const email = el.find('#customer-password-email').val();
                            const password1 = el.find('#customer-password-1').val();
                            const password2 = el.find('#customer-password-2').val();

                            const set_password = await fetch(Subscribe.stripe_api_target_url, {
                                method: 'POST',
                                mode: 'same-origin',
                                body: JSON.stringify({
                                    'trigger': 'set_password',
                                    session,
                                    email,
                                    password1,
                                    password2
                                })
                            });
                            const set_password_data = await set_password.json();
                            if (set_password_data.status === 'ERROR') {
                                alert(set_password_data.message);
                                setLoading(false);
                                return false;
                            }

                            if (set_password_data.status === 'SUCCESS') {
                                if (success_url) {
                                    window.location.replace(success_url);
                                    return false;
                                }
                                location.reload();
                            } else {
                                setLoading(false);
                                return false;
                            }
                        }
                    }

                    el[0]
                        .addEventListener("submit", handleSubmit);
                    if (skipfirst && stage === 1) {
                        el.find('button[type="submit"]').click();
                        //     await el[0].submit();
                    }
                }


            }
        })();
    });